export default __webpack_public_path__ + "images/316f48255b80c1c84ca750492ffa9456-holiday.webp";